import type { NextRouter } from "next/router";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";
import { useLoginPasswordSubmissionPart } from "@Front/Components/Layouts/Login/hooks/helpers/loginPasswordFlowSubmissionPart";
import { useLoginPasswordRecoveryPart } from "@Front/Components/Layouts/Login/hooks/helpers/loginPasswordFlowRecoveryPart";

export function useAssembledLoginPasswordHandlers(params: {
	router: NextRouter;
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
	refresh: () => Promise<void>;
}): {
	onNewPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordForgotClicked: () => void;
	onSendAnotherCode: () => void;
} {
	const { router, loginScope, loginState, refresh } = params;
	const submissions = useLoginPasswordSubmissionPart({ router, loginScope, loginState, refresh });
	const recovery = useLoginPasswordRecoveryPart({ loginScope, loginState });
	return {
		...submissions,
		...recovery,
	};
}
